import { CCStyling, DefaultStyling } from "../CCStyling";
import {
  convertAttrsToString,
  convertInputVariantToType,
  createElement
} from "../CCUtility";
import { CCInputVariant, CCTextVariant } from "../types/variants";

export function CCWrapper(
  content: string,
  classList: string = "",
  styling: CCStyling = DefaultStyling.blank,
  htmlAttributes: Record<string, string> = {}
): string {
  return createElement(
    "div",
    classList,
    CCStyling.join(DefaultStyling.wrapper, styling),
    content,
    htmlAttributes
  );
}

export function CCText(
  variant: CCTextVariant,
  textClass: string,
  content: string,
  styling: CCStyling = DefaultStyling.blank,
  htmlAttributes: Record<string, string> = {}
): string {
  return createElement(
    variant,
    textClass,
    CCStyling.join(DefaultStyling.text, styling),
    content,
    htmlAttributes
  );
}

export function CCHeader(
  variant: CCTextVariant,
  textClass: string,
  content: string,
  styling: CCStyling = DefaultStyling.blank,
  htmlAttributes: Record<string, string> = {}
): string {
  const style = CCStyling.join(DefaultStyling.header, styling);
  style.override = true;
  return CCText(variant, textClass, content, style, htmlAttributes);
}

export function CCInput(
  variant: CCInputVariant,
  label: string,
  key: string,
  classList: string,
  styling: CCStyling = DefaultStyling.blank,
  {
    includeWrapper = true,
    selectOptions = [],
    selectDefaultOption = "Choose",
    paragraphWordLimit = undefined,
    htmlAttributes = {},
    indexInStructure
  }: {
    includeWrapper?: boolean;
    selectOptions?: string[];
    selectDefaultOption?: string;
    paragraphWordLimit?: number;
    htmlAttributes?: Record<string, string>;
    indexInStructure?: number;
  } = {}
): string {
  if (variant === "Select")
    return CCSelect(
      label,
      key,
      classList,
      styling,
      includeWrapper,
      selectOptions,
      selectDefaultOption,
      htmlAttributes
    );
  if (variant === "Radio") {
    return CCRadio(
      label,
      key,
      classList,
      styling,
      includeWrapper,
      selectOptions,
      htmlAttributes,
      indexInStructure
    );
  }
  let content: string = "";
  if (label) {
    content = CCText(
      "h5",
      variant === "Paragraph" ? "confParagraphTitle" : "",
      label + (variant === "Check" ? "" : ": "),
      styling,
      variant === "Paragraph"
        ? {
            "data-label-for": key
          }
        : {}
    );
  }
  const isRich = classList.includes("richTextEnabled");
  let tag = "input";
  if (variant === "Paragraph") {
    tag = isRich ? "div" : "textarea";
    if (paragraphWordLimit != undefined) {
      htmlAttributes["data-paragraph-word-limit"] = String(paragraphWordLimit);
    }
  }
  const inner =
    (variant === "Check" ? "" : content) +
    `<${tag} ` +
    convertAttrsToString(htmlAttributes) +
    `class="form-control conf${variant} ${classList}" ` +
    `${classList.includes("richTextEnabled") ? `id="rtt-${key}" ` : ""}` +
    `type="${convertInputVariantToType(variant)}" ` +
    `data-key="${key}" ` +
    `value="" ` +
    `style="${CCStyling.join(DefaultStyling[variant], styling).compile()}">` +
    `</${tag.split(" ")[0]}>` +
    (variant === "Check" ? content : "");
  return includeWrapper ? CCWrapper(inner) : inner;
}

export function CCSelect(
  label: string,
  key: string,
  classList: string,
  styling: CCStyling = DefaultStyling.blank,
  includeWrapper: boolean = true,
  options: string[],
  defaultOption: string,
  htmlAttributes: Record<string, string> = {}
): string {
  let content: string = label ? CCText("h5", "", label + ": ", styling) : "";
  const inner =
    content +
    `<select class="form-control confSelect ${classList}" ` +
    convertAttrsToString(htmlAttributes) +
    `data-key="${key}" ` +
    `style="${CCStyling.join(DefaultStyling.Select, styling).compile()}">` +
    `<option class="defaultCCSelectOption" value="${defaultOption}">${defaultOption}</option>` +
    `${options.map((option) => `<option value="${option}">${option}</option>`).join("")}` +
    `</select>`;
  return includeWrapper ? CCWrapper(inner) : inner;
}
export function CCRadio(
  label: string,
  key: string,
  classList: string,
  styling: CCStyling = DefaultStyling.blank,
  includeWrapper: boolean = true,
  options: string[],
  htmlAttributes: Record<string, string> = {},
  indexInStructure: number
): string {
  let content: string = "";
  if (label) {
    content = CCHeader("h5", "", label, styling);
  }
  const inner =
    content +
    `<div class="cc-radio-wrapper ${classList}" ${convertAttrsToString(htmlAttributes)} data-key="${key}" style="${CCStyling.join(DefaultStyling.RadioDiv, styling).compile()}">` +
    options
      .map((option, i) => {
        return `<input class="confRadio" data-radio-value="${option}" type="radio" id="cc-radio-opt-${indexInStructure}-${i}" name="cc-radio-opt-${indexInStructure}" style="${DefaultStyling.RadioInput.compile()}"/><label style="${DefaultStyling.RadioLabel.compile()} "for="cc-radio-opt-${indexInStructure}-${i}">${option}</label><br/>`;
      })
      .join("") +
    "</div>";
  return includeWrapper ? CCWrapper(inner) : inner;
}
